export const testimonials = [
  {
    id: 1,
    name: 'Marie-Claire Dupont',
    city: 'Châteauroux',
    rating: 5,
    text: 'Apex Rénovation a rénové intégralement notre appartement de 85 m² en seulement 6 semaines. L\'équipe était professionnelle, ponctuelle et les finitions sont impeccables. Le conducteur de travaux nous tenait informés chaque semaine. Je recommande sans hésitation !',
    service: 'Rénovation Intérieure Complète',
    date: 'Janvier 2025',
    avatar: 'MC',
  },
  {
    id: 2,
    name: 'Thomas Beaulieu',
    city: 'Issoudun',
    rating: 5,
    text: 'Notre cuisine a été entièrement repensée et réalisée par Apex Rénovation. La conception 3D nous a permis de visualiser le résultat avant même le début des travaux. La pose a été parfaite et le résultat dépasse nos espérances. Équipe très à l\'écoute.',
    service: 'Rénovation de Cuisine',
    date: 'Novembre 2024',
    avatar: 'TB',
  },
  {
    id: 4,
    name: 'Jean-François Aubert',
    city: 'La Châtre',
    rating: 4,
    text: 'La rénovation de notre salle de bain s\'est parfaitement déroulée. Nous avons opté pour une douche à l\'italienne et un double vasque. Le carreleur est très talentueux. Un léger retard dû à la livraison de la robinetterie, mais l\'équipe a bien géré la situation.',
    service: 'Rénovation de Salle de Bain',
    date: 'Décembre 2024',
    avatar: 'JA',
  },
  {
    id: 5,
    name: 'Isabelle Renard',
    city: 'Argenton-sur-Creuse',
    rating: 5,
    text: 'Le ravalement de façade de notre maison de 1960 a été une vraie transformation. Apex Rénovation a su respecter le style local tout en modernisant l\'aspect de la maison. Les travaux ont été réalisés en 2 semaines, avec une équipe discrète et soigneuse.',
    service: 'Ravalement de Façade',
    date: 'Septembre 2024',
    avatar: 'IR',
  },
  {
    id: 6,
    name: 'Pierre-Luc Moreau',
    city: 'Châteauroux',
    rating: 5,
    text: 'Apex Rénovation a aménagé nos nouveaux bureaux de 200 m² pour notre PME. Résultat magnifique et fonctionnel, avec des cloisons acoustiques et une salle de réunion vitrée. L\'équipe a travaillé le week-end pour ne pas perturber notre activité.',
    service: 'Aménagement de Bureau',
    date: 'Février 2025',
    avatar: 'PM',
  },
];

export default testimonials;
